import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function StartDatePicker({passStartDate}) {
  const [startDate, setStartDate] = useState(null);

  function handleDateChange(date) {
    const str = JSON.stringify(date.toLocaleDateString("el-GR", { timeZone: "Europe/Athens" }));
    
    let get_day = str.substring(1,str.length-1)
    get_day = get_day.replace(/-/g, "/");
    let myArray = get_day.split("/");
    let fin_string = myArray[0] + "/" + myArray[1]  + "/" + myArray[2] 
    
    setStartDate(date)
    passStartDate(fin_string)
  }


  return (
    <div>
      <label>From:</label>
      <DatePicker
        selected={startDate}
        onChange={(date) => handleDateChange(date)}
        selectsStart
        startDate={startDate}
        maxDate={new Date("2017-12-31")}
        minDate={new Date("2010-01-01")}
      />
    </div>
  );
}

export default StartDatePicker;
